import { css } from 'emotion'
import * as React from 'react'
import { connect } from 'react-redux'

import { Field, FieldDataValue } from 'embed/constants'
import { defaultCreditScoreUrl } from 'embed/constants/config'
import { Fields } from 'embed/constants/fields'

import { StepTitle } from 'embed/components/Application/StepTitle'
import { FieldTooltip } from 'embed/components/ApplicationField/FieldTooltip'
import { ApplicationField } from 'embed/components/ApplicationField/container'
import ThemeConsumer from 'embed/components/ThemeConsumer'
import { configFloatingLabelInputsSelector } from 'embed/selectors/config'
import { Product } from 'even-ts-static'
import Wrapper from '../Wrapper'

const styles = require('embed/styles/application')
const TransUnion = require('assets/components/transunion.svg')

export interface Props {
  creditScoreOfferUrl: string
  directReferral: boolean
  dispatchBackToStepOne: () => void
  handleChangeAndContinue: (field: Field, value: string) => void
  hideLoanPurpose: boolean
  loanPurposeOnChange?: (value: FieldDataValue) => void
  onBack: () => void
  onContinue: () => void
  stepByStepApplicationStepIsValid: boolean
  currentStep: number
  totalNumberOfSteps: number
  useFloatingLabelInputs?: boolean
}

export const StepbystepApplicationStepCreditRating: React.FunctionComponent<Props> = (props) => (
  <ThemeConsumer>
    {({ colorPrimary }) => (
      <Wrapper {...props}>
        <StepTitle>
          What’s your approximate credit rating?
          {props.useFloatingLabelInputs && (
            <>
              {' '}
              <FieldTooltip
                className={styles.questionTooltip}
                field={Fields.CreditRatingButtonList}
                useFloatingLabelInputs={true}
                shouldShowIsInvalid={false}
              />
            </>
          )}
        </StepTitle>
        <ApplicationField
          onChange={props.handleChangeAndContinue.bind(null, Fields.CreditRatingButtonList)}
          product={Product.Loan}
          field={Fields.CreditRatingButtonList}
        >
          <div className={styles.creditScore}>
            <a
              data-test-id="app_creditScoreLink"
              className={css`
                color: ${colorPrimary};
              `}
              href={props.creditScoreOfferUrl ?? defaultCreditScoreUrl}
              target="_blank"
            >
              <span>Don't know? Click here to get your score.</span>
            </a>
          </div>
        </ApplicationField>
      </Wrapper>
    )}
  </ThemeConsumer>
)

const mapStateToProps = (state) => ({
  useFloatingLabelInputs: configFloatingLabelInputsSelector(state),
})

export default connect(mapStateToProps)(StepbystepApplicationStepCreditRating)
